import { useSelector } from 'react-redux';
import {
  ruler2dTimestampRangeSelector,
  ruler2dVoltageRangeSelector,
} from '../selectors/ruler2d.selectors';
import { computeInterval } from 'features/episodeMeasurement/utils/episode-measurement.utils';
import { MINUTE } from 'features/utils/time';

export const useRuler2dMetrics = () => {
  const [ruler2dStart, ruler2dEnd] = useSelector(ruler2dTimestampRangeSelector);
  const [voltageStart, voltageEnd] = useSelector(ruler2dVoltageRangeSelector);

  const voltage = Math.round((voltageEnd - voltageStart) * 100) / 100;
  const duration = computeInterval(ruler2dStart, ruler2dEnd);
  const beatsPerMinute = Math.round(MINUTE / duration);

  return `${voltage}mV, ${duration}ms, ${beatsPerMinute}bpm`;
};
